import React from "react";

import DogImage from "../assets/img/dogs/dog-appointment.png";

const Form = () => {
  return (
    <section className="bg-yellow-secondary py-12 lg:pb-12 lg:mt-32 relative min-h-[584px]">
      <div className="container mx-auto">
        <div>
          <div className="hidden w-full max-w-[790px] mx-auto lg:flex justify-center">
            <img src={DogImage} alt="" />
          </div>
          <form className="bg-yellow py-8 px-6 w-full 
          max-w-[790px] h-[500px] mx-auto lg:-mt-5
           rounded-[60px] text-center flex flex-col
           justify-start items-center gap-y-4
           ">
            <h2 className="h2 my-4">Fale com o nosso pessoal</h2>
            <input type="text" className="input-control placeholder-orange" placeholder="Seu nome" />
            <input type="text" className="input-control placeholder-orange" placeholder="Seu email"/>
            <textarea className="resize-none w-full max-w-[514px] rounded-3xl h-60 p-4 outline-none border-none placeholder-orange" placeholder="Sua menssagem"></textarea>
            <button className="btn w-full max-w-[514px]">Enviar</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Form;
